module.exports = __webpack_public_path__ + "img/jihuidian2.465a11dd.png";